module.exports = __webpack_public_path__ + "static/img/muwanguzi.1cdc96b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads/muwanguzi.jpg
// module id = 76
// module chunks = 1